const feedSteps = [
  {
    popover: {
      title: "Welcome to the Feed",
      description: "This is where all available rides and requests appear. Let's walk through the key features.",
    },
  },
  {
    element: '[data-tour="feed-chips"]',
    popover: {
      title: "Filter by City",
      description: "Tap any city chip to filter rides by departure or arrival location. Select multiple cities to narrow your search.",
    },
  },
  {
    element: '[data-tour="feed-sort"]',
    popover: {
      title: "Sort Rides",
      description: "Sort rides by newest or oldest departure date to find what suits you best.",
    },
  },
  {
    element: '[data-tour="feed-card"]',
    popover: {
      title: "Ride Card",
      description: "Each card shows the route, date, and driver. Tap a card to view full details and book a seat.",
    },
  },
  {
    element: '[data-tour="feed-pagination"]',
    popover: {
      title: "More Rides",
      description: "Browse through pages to see all available rides. New rides appear as they are posted.",
    },
  },
];

export default feedSteps;
